import { IbssComponent } from "../BaseComponent/IbssComponent";
import { appContext } from "../../../AppContext";
import { IRouterProps } from "@iconics/components";

export abstract class IbssPage<TProps, TState> extends IbssComponent<TProps, TState>
{
    private get _appState() { return appContext().state; }

    private _routerProps: (TProps & IRouterProps) | null = null;
    private get routerProps(): TProps & IRouterProps
    {
        if (!this._routerProps)
        {
            this._routerProps = this.toRouterProps(this.props);
        }
        return this._routerProps;
    }

    private toRouterProps(props: TProps): TProps & IRouterProps
    {
        if (!('navigate' in this.props) || !('params' in this.props) || !('location' in this.props))
        {
            throw new Error("To use routing, wrap the current page in 'withRouting()'.");
        }
        return props as TProps & IRouterProps;
    }

    public get pageTitle(): string
    {
        return this._appState.pageTitle;
    }

    public set pageTitle(value: string)
    {
        this._appState.set({ pageTitle: value });
    }

    public get backUrl(): string
    {
        return this._appState.backUrl;
    }

    public set backUrl(value: string)
    {
        this._appState.set({ backUrl: value });
    }

    // todo: derived class must call super.componentWillUnmount() if over-ridden
    public componentWillUnmount(): void
    {
        this.pageTitle = "";
        this.backUrl = "";
    }
}
